import { render } from "./verify-token.vue?vue&type=template&id=4e198394"
import script from "./verify-token.vue?vue&type=script&lang=js"
export * from "./verify-token.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__